module.exports = __webpack_public_path__ + "static/campbrain-logo-1f78e099e51af292bbff6a54da13f86e.jpg";